import { useT } from '../i18n/LanguageProvider';

interface Props {
  label: string;
  options: string[];
  active: string;
  onChange: (value: string) => void;
}

export const ALL = 'all';

export default function FilterChips({ label, options, active, onChange }: Props) {
  const t = useT();

  return (
    <div className="filters" role="group" aria-label={label}>
      <button
        className="chip"
        type="button"
        aria-pressed={active === ALL}
        onClick={() => onChange(ALL)}
      >
        {t.common.all}
      </button>
      {options.map((option) => (
        <button
          key={option}
          className="chip"
          type="button"
          aria-pressed={active === option}
          onClick={() => onChange(option)}
        >
          {option}
        </button>
      ))}
    </div>
  );
}
